import { Button, Container, PortalLayout, Stack, Typography } from "../../design-system";
import { linkUnavailableContent } from "./content";

export interface LinkUnavailablePageProps {
  /** The one action this view offers (AC-24): opens the sign-in view. */
  onGetNewLink: () => void;
}

/**
 * /sign-in/link-unavailable (design state 1.4, AC-24, AC-29, ADR-20261008-
 * evet). The one view shown for every rejected link: a confirm that
 * returns not-found for any AC-7 cause (never issued, structurally
 * invalid, altered, expired, spent, superseded or revoked), a magic-link
 * URL whose fragment is missing or malformed, and a session that has
 * ended (AC-9, AC-24). Its rendered body is byte-identical across every
 * one of those causes -- this component reads no outcome of its own, the
 * same structural guarantee `CheckEmailPage` uses, so there is nothing in
 * its inputs that could make it vary. It carries no email field, no
 * policy number, no renewal date and no account name.
 */
export function LinkUnavailablePage({ onGetNewLink }: Readonly<LinkUnavailablePageProps>) {
  return (
    <PortalLayout headerVariant="entry" helpLine={linkUnavailableContent.helpLine} background="white">
      <Container layout="entry">
        <Stack gap="field">
          <Typography variant="display" as="h1">
            {linkUnavailableContent.heading}
          </Typography>
          <Typography variant="bodyLarge">{linkUnavailableContent.body}</Typography>
          <Button emphasis="primary" onClick={onGetNewLink} size="large" fullWidth>
            {linkUnavailableContent.newLinkActionLabel}
          </Button>
        </Stack>
      </Container>
    </PortalLayout>
  );
}
